import { BookmarkIdsDocument } from '../../graphql/graphql';

export const getBookmarkIds = BookmarkIdsDocument;
